"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("./core");
exports.default = core_1.TsSelect2;
Object.assign(module.exports, core_1.TsSelect2);
//# sourceMappingURL=browser.js.map